import { API } from "apis";
import PageTitle from "components/common/PageTitle";
import FavoriteCorps from "components/mypage/FavoriteCorps";
import FavoriteItems from "components/mypage/FavoriteItems";
import {
  ContextModel,
  FavoriteCorpListModel,
  FavoriteCorpModel,
  FavoriteItemListModel,
  FavoriteItemModel,
} from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useOutletContext } from "react-router-dom";
import { Utils } from "utils";

const Mypage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();

  const didEffect = React.useRef(false);

  // お気に入り商品
  const [items, setItems] = React.useState<FavoriteItemModel[]>([]);
  // お気に入り会社
  const [corps, setCorps] = React.useState<FavoriteCorpModel[]>([]);

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(true);

      await ctx.auth.initialize();
      await ctx.limitPrice.load();

      if (!ctx.auth.data?.is_admin_corp) {
        try {
          const api = [
            API.FavoriteItem.search({ get_count: 4 }, true),
            API.FavoriteCorp.search({ get_count: 4 }, true),
          ];
          const response = await Promise.all(api);
          const items = response[0].data as FavoriteItemListModel;
          setItems(items.favorite_item_list);
          const corps = response[1].data as FavoriteCorpListModel;
          setCorps(corps.favorite_corp_list);
        } catch (err) {
          Utils.errorAction(ctx, err);
        }
      }

      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>マイページ</title>
      </Helmet>
      <PageTitle title="マイページ" className="p-2" />

      {!ctx.auth.data?.is_admin_corp && (
        <>
          {/* お気に入り商品 */}
          <FavoriteItems items={items} />

          {/* お気に入り会社 */}
          <FavoriteCorps items={corps} />
        </>
      )}
    </>
  );
};
export default Mypage;
